import ConsultingHero from "../shared/ConsultingHero/ConsultingHero";
import AssociatedServices from "../shared/AssociatedServices/AssociatedServices";
import MascotIntroSection from "../shared/MascotIntroSection/MascotIntroSection";
import { grantWritingSponsorships, grantWritingAssociatedServices } from "./data/consultingData";

const GrantWritingService = () => {

  return (
    <div>
      <ConsultingHero
        title={
          <>
            <span className="block">Streamline your</span>
            <span className="block">grant writing</span>
            <span className="block">process</span>
          </>
        }
        buttonText="Book an AI Funding Strategy Call"
        buttonTo="/contact-us"
        bgColor="bg-gradient-to-b from-orange-amber to-orange-gold"
        imageSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/cat-in-wall-480.webp"
        imageSrcSet="
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/cat-in-wall-480.webp 480w,
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/cat-in-wall-1280.webp 1280w,
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/cat-in-wall-1920.webp 1920w
        "
        imageAlt="A kitten peeking through a torn orange wall"
        imageClassName="object-center md:object-[center_30%] md:translate-x-32 lg:translate-x-44 xl:translate-x-52"
      />

      <MascotIntroSection
        mascotSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-cheer.webp"
        mascotAlt="Starski mascot cheering"
        circleBg="bg-orange"
        title="Win more grants"
        description="Our proprietary Grant Writing application blends seasoned grant strategists with cutting-edge AI search, customized Grant ranking, and writing tools—so you see funding results in a fraction of the time."
      />

      {/* Why traditional grant writing falls short section */}
      <section className="flex flex-col md:flex-row w-full my-16 md:my-24 lg:my-32 xl:my-52">
        <div className="bg-blue-light1 px-8 md:px-12 lg:px-16 xl:px-24 py-12 md:py-16 lg:py-20 md:w-1/2 text-center md:text-left">
          <h2 className="text-3xl md:text-3xl lg:text-4xl xl:text-7xl font-bold text-blue-navy mb-6 xl:mb-12">
            Why traditional grant writing falls short
          </h2>
          <p className="!text-sm md:!text-base xl:!text-2xl leading-relaxed mb-6">
            There’s over 9,000 active grants at any given time. 
            Only 1 in 10 proposals are funded because nonprofits chase the wrong opportunities, miss hidden data points, or run out of time.
          </p>
          <p className="!text-sm md:!text-base xl:!text-2xl leading-relaxed mb-6">
              We can effortlessly scan every possible grant that you would be eligible for and have created a propriety scoring system to prioritize the  grants that align with your mission.  with the highest chance of securing funding
          </p>
          <p className="!text-sm md:!text-base xl:!text-2xl leading-relaxed">
            <strong>
              We eliminate the manual process—so your team can stay focused on impact.
            </strong>
          </p>
        </div>
        <div className="md:w-1/2 h-[300px] md:h-auto">
          <img
            src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/grant-writing.png"
            alt="Grant writing"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </section>

      {/* How we help you win sponsorships section */}
      <section className="px-4 md:px-8 lg:px-16 xl:px-24 my-16 md:my-24 lg:my-32 xl:my-52">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col items-center mb-12">
            <img
              src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/horizontal-line.svg"
              alt=""
              className="w-28 md:w-40 mb-4"
            />
            <h2 className="text-2xl md:text-5xl lg:text-6xl xl:text-8xl font-bold text-blue-dark1 text-center mb-4 md:mb-8">
              How we help you win sponsorships
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {grantWritingSponsorships.map((card, index) => (
              <div
                key={index}
                className={`${card.bg} text-black rounded-2xl p-6 lg:p-8 flex flex-col text-left`}
              >
                <h3 className="font-bold text-xl lg:text-3xl xl:text-5xl mb-4">
                  {card.title}
                </h3>
                <img
                  src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/white-horizontal-line.svg"
                  alt=""
                  className="w-14 mb-6"
                />
                <div className="mb-4 flex gap-3">
                  <img
                    src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/check.svg"
                    alt=""
                    className="w-5 h-5 mt-0.5 min-w-[20px]"
                  />
                  <div>
                    <p className="!text-sm md:!text-base font-bold mb-1">Action:</p>
                    <p className="!text-sm md:!text-base leading-relaxed">{card.action}</p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <img
                    src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/sparkle.svg"
                    alt=""
                    className="w-5 h-5 mt-0.5 min-w-[20px]"
                  />
                  <div>
                    <p className="!text-sm md:!text-base font-bold mb-1">Outcome:</p>
                    <p className="!text-sm md:!text-base leading-relaxed">{card.outcome}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <AssociatedServices
        subtitle="More ways to grow your audience."
        services={grantWritingAssociatedServices}
        cols={2}
      />
    </div>
  );
};

export default GrantWritingService;
